(function () {
  'use strict';

  const SELECTOR = '.ils-section';

  function debounce(fn, wait) {
    let timer;
    return function debounced(...args) {
      clearTimeout(timer);
      timer = window.setTimeout(() => fn.apply(this, args), wait);
    };
  }

  // Keeps a value inside (-range, 0], wrapping either direction of growth.
  function wrap(value, range) {
    if (!range) return 0;
    let r = value % range;
    if (r > 0) r -= range;
    return r;
  }

  function setup(section) {
    if (!section || section.dataset.ilsReady === 'true') return;

    const track = section.querySelector('.ils-track');
    const viewport = section.querySelector('.ils-viewport');
    const baseSet = track ? track.querySelector('.ils-set') : null;
    if (!track || !viewport || !baseSet) return;

    section.dataset.ilsReady = 'true';

    const speedSeconds = parseFloat(section.dataset.ilsSpeed) || 30;
    const rtlFlip = section.dataset.ilsRtlFlip === 'true';
    const isRtlPage = getComputedStyle(document.documentElement).direction === 'rtl';
    let directionSign = section.dataset.ilsDirection === 'right' ? 1 : -1;
    if (rtlFlip && isRtlPage) directionSign *= -1;
    const pauseOnHover = section.dataset.ilsPause === 'true';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let loopDistance = 0;
    let offset = 0;
    let paused = false;
    let lastTime = null;

    function cloneSet() {
      const clone = baseSet.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('data-ils-clone', 'true');
      clone.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
      track.appendChild(clone);
      return clone;
    }

    function layout() {
      const setWidth = baseSet.getBoundingClientRect().width;
      if (!setWidth) return;

      // Reset to just the template's own sets, then top up with clones
      // until the track is comfortably wider than 2x the viewport — this
      // guarantees a seamless loop no matter how few/narrow the images are.
      track.querySelectorAll('.ils-set[data-ils-clone]').forEach((el) => el.remove());

      const viewportWidth = viewport.getBoundingClientRect().width;
      const needed = viewportWidth * 2 + setWidth;

      let total = track.scrollWidth;
      let guard = 0;
      while (total < needed && guard < 40) {
        cloneSet();
        total += setWidth;
        guard += 1;
      }

      loopDistance = setWidth;
    }

    function tick(time) {
      window.requestAnimationFrame(tick);

      if (lastTime === null) lastTime = time;
      const dt = Math.min((time - lastTime) / 1000, 0.1);
      lastTime = time;

      if (paused || !loopDistance) return;

      const pxPerSecond = loopDistance / speedSeconds;
      offset = wrap(offset + directionSign * pxPerSecond * dt, loopDistance);
      track.style.transform = `translateX(${offset}px)`;
    }

    layout();

    if (pauseOnHover) {
      viewport.addEventListener('mouseenter', () => { paused = true; });
      viewport.addEventListener('mouseleave', () => { paused = false; });
    }

    window.addEventListener('resize', debounce(layout, 150));

    const images = Array.from(track.querySelectorAll('img'));
    images.forEach((img) => {
      if (img.complete) return;
      const done = () => layout();
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    });

    if (reducedMotion) {
      // Respect the OS/browser preference: leave it static, scrollable by hand.
      return;
    }

    window.requestAnimationFrame(tick);
  }

  function initAll(container) {
    const scope = container || document;

    if (scope.matches && scope.matches(SELECTOR)) {
      setup(scope);
      return;
    }

    scope.querySelectorAll(SELECTOR).forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
